export default __webpack_public_path__ + "static/media/laur.6b248822.jpg";